import styled from 'styled-components'

const Container = styled.div`
   background: #303030;
    color: white;
    height: 30px;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    justify-content: center;
`


const Annoucement = () => {
    return (
        <Container>
         
        </Container>
    )
}

export default Annoucement
